import { ExportButton } from "@/components/export/ExportButton";
import PageHeader from "@/components/PageHeader";
import Title from "@/components/Title";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
} from "@/components/ui/card";
import MonthYearNavigation from "@/components/MonthYearNavigation";
import { usePeriodQueryParams } from "@/hooks/usePeriodQueryParams";
import { Module } from "@/constants";
import { useSchedulesReportBreadcrumb } from "@/modules/schedulesReport/hooks/useSchedulesReportBreadcrumb";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const SchedulesReport = () => {
  const { t } = useTranslation();
  const breadcrumbItems = useSchedulesReportBreadcrumb();
  const [month, setMonth] = useState<Date>(new Date());
  const queryParams = usePeriodQueryParams(month);

  return (
    <div>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <Card>
        <CardHeader>
          <Title>{t("reports.navigation.schedulesReport")}</Title>
          <CardDescription>
            {t("reports.schedulesReport.description")}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-row gap-2 items-center">
            <MonthYearNavigation value={month} onMonthChange={setMonth} />
            <ExportButton
              moduleName={Module.SchedulesReport}
              queryParams={queryParams}
              variant="default"
            >
              {t("reports.schedulesReport.exportReport")}
            </ExportButton>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export { SchedulesReport };
